import { useEffect, useState } from 'react';

type UseAutoSlideProps = {
  totalSlides: number;
  interval?: number;
  isActive?: boolean;
};

export const useAutoSlide = ({ totalSlides, interval = 3000, isActive = true }: UseAutoSlideProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isActive) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, interval);

    return () => clearInterval(timer);
  }, [totalSlides, interval, isActive]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToIndex = (index: number) => {
    setCurrentIndex(index);
  };

  return {
    currentIndex,
    goToNext,
    goToPrev,
    goToIndex,
  };
};
